import * as React from 'react';
const { connect } = require('react-redux');
import * as i18n from 'i18next';
import * as XHR from 'i18next-xhr-backend';
import { I18nextProvider } from 'react-i18next';
import { IStore } from 'redux/IStore';
import { IFetchDefault } from 'redux/modules/fetch';
import * as c from 'models/constants';

interface IProps {
	initialData?: IFetchDefault;
}
export const I18nextSettings = {
	backend: {
		loadPath: '',
		crossDomain: true,
	},
	defaultNS: 'translation',
	load: 'currentOnly',
	fallbackLng: c.LANGUAGE_EN_US,
	react: {
		wait: true,
	},
};
@connect(
	(state: IStore) => ({
		initialData: state.fetchDefault,
	}),
	(dispatch) => ({
		dispatch,
	}),
)
class I18nextProviderWrapper extends React.Component<IProps, any> {
	private i18nextinstance: any = null;

	constructor(props: IProps) {
		super(props);

		if (!this.i18nextinstance) {
			const settings = I18nextSettings;
			settings.backend.loadPath =
				this.props.initialData.baseAPI + 'Resources/Resources.{{lng}}.json?v=' + process.env.CACHE_VERSION;
			this.i18nextinstance = i18n.use(XHR).init(settings);
		}
	}

	public render() {
		return <I18nextProvider i18n={this.i18nextinstance}>{this.props.children}</I18nextProvider>;
	}
}

export { I18nextProviderWrapper };
